module.exports = __webpack_public_path__ + "img/bgtop.0287585d.jpg";